import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import $ from "jquery";

export default class Cursor {
  cursorName = null;
  addedImages = [];

  registerEvents = () => {
    eventManager.addEvent(
      eventManager.events.RENDER,
      this.renderCursor,
      this,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      this.onMouseUp,
      this,
      eventManager.priorities.OVERALL
    );
  };

  onMouseUp = () => {
    this.checkForRestoreCursor();
  };

  setCursorImage = (imgSrc) => {
    const alreadyAddedImage = this.addedImages.find(image => image.dataset.id === this.clickedEdgeButton.attr("data-id"));
    if (alreadyAddedImage) {
      this.cursorImage = { image: alreadyAddedImage, width: alreadyAddedImage.width, height: alreadyAddedImage.height };
      eventManager.setCursor('edge-select', this, true);
      this.registerEvents();
    } else {
      this.addCursorImage(imgSrc);
    }
  };

  addCursorImage = (imgSrc) => {
    let item = this.clickedBackSplashButton, // remember it to restore after moving canvas cursor switch
      bounds = 18,
      imgWidth = bounds,
      imgHeight = bounds;
    void item;

    let domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";
    domImg.dataset.name = "cursor";

    let $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });
    // $img.attr({
    //   'data-id': item.attr('data-id'),
    //   'data-name': item.attr('data-name').trim(),
    //   'data-name-metric': item.attr('data-name-metric').trim(),
    // });
    let imgOnLoad = () => {
      let bounds = 18, ratio;
      if (imgWidth > imgHeight) {
        ratio = imgHeight / imgWidth;
        imgWidth = bounds;
        imgHeight = bounds * ratio;
      } else {
        ratio = imgWidth / imgHeight;
        imgHeight = bounds;
        imgWidth = bounds * ratio;
      }
      eventManager.setCursor('edge-select', this, true);
      this.cursorImage = { image: domImg, width: imgWidth, height: imgHeight };
      this.registerEvents(); // only after image is load!
    };
    $img.on('load', imgOnLoad);
    $img.appendTo($('body'));

    config.highlight.type = 'backsplash';
    //todo
    $img.attr('src', imgSrc);

    // config.highlight.id = item.attr('data-id');
  };

  checkForRestoreCursor = () => {
    if (this.isWaitingToRestoreCursor) {
      this.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(this, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage

      //todo
      // this.setHighlighting();
      this.setCursorImage();
    }
  };

  renderCursor = function(ctx) {
    if(this.cursorImage.image && ($(window).width() > 768)) {
      let mPos = eventManager.LastKnownMousePos;
      if(mPos) {
        ctx.drawImage(this.cursorImage.image, mPos.x + 10, mPos.y + 10, 18, 18);
      }
    }
  };

  destroy = (protect, revertBackAfterMouseUp) => {
    if (revertBackAfterMouseUp) {
      //remove render only, but wait for mouse up to set cursor again
      //eventManager.removeEvent(this, eventManager.events.RENDER);

      //full remove event
      this.deregisterEvents();
      this.cursorImage = null;
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
      this.cursorImage = null
    }
    this.hide();
  };

  hide = function(e) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    //Menu.hideSideBarContent(); // hide sidebar menu
  };

  deregisterEvents = () => {
    eventManager.resetCursor(this);
    eventManager.removeEvent(this);
    config.highlight.lines = false;
  }
}
